'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { Edit } from '@/shared/components/icons';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import { useProfileContext } from '../../hooks/use-profile-context';
import * as Styled from './edit-button.styled';
export const EditButton = React.memo(function EditButton() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const {
    setIsEditMode
  } = useProfileContext();
  const handleEdit = () => {
    setIsEditMode(true);
  };
  return <Styled.ActionButton size="s" icon={Edit} onClick={handleEdit} {...buildQaTrackingEntityProps('newProfile.header.editProfile')}>
      {profileModel.strings.edit}
    </Styled.ActionButton>;
});